export const issuesFilterOptions = [
    {value: 'SMS', label: 'SMS'},
    {value: 'OVER_SMS', label: 'Over SMS'},
    {value: 'WATER', label: 'Water'},
    {value: 'BATTERY_ERROR', label: 'Battery Error'},
    {value: 'LOW_BATTERY', label: 'Low Battery'},
    {value: 'MO_FAILURE', label: 'Manual Override Failure'},
    {value: 'VALVE_ERROR', label: 'Valve Error'},
    {value: 'ACT_ON_LEAK', label: 'Act On Leak'},
    {value: 'VALVE_MISMATCH', label: 'Valve Mismatch'},
    {value: 'LPH_MISMATCH', label: 'LPH Mismatch'},
    {value: 'SD', label: 'SD'},
    {value: 'ALGO_THRESHOLD', label: 'Algo Threshold'},
    {value: 'RESET', label: 'Reset'},
    {value: 'REPLACE_SD', label: 'Replace SD'},
    {value: 'CLOCK_DEVIATION', label: 'Clock Deviation'},
    {value: 'ULTRASONIC_AC_UNPLUGGED', label: 'Ultrasonic AC Unplugged'},
    {value: 'RESETTING', label: 'Resetting'},
    {value: 'FALLBACK_RESET', label: 'Fallback Reset'},
    {value: 'MISSING_ULTRASONIC_CONFIG', label: 'Missing Ultrasonic Configuration'},
    {value: 'AC_UNPLUGGED', label: 'AC Unplugged'}
];
